import { isObject, isString } from 'lodash'
import { DEFAULT_COLORS_WIDGETS } from '@components/widgets/apacheEchart/Commons'
import { CommonWidgetParams } from '../dashWidgetHelper'

export const lineDetailedMonthAndGeoMapper = (data: any) => {
  console.log('lineDetailedByMonthAndGeo!!!!!!!!')
  console.log(data)
  return {
    value: data !== undefined && data.map !== undefined
      ? data.map((item: any, idx: number) => ({
        ...item,
        id: idx,
        category: item.groupName ? item.groupName : item['group_0'],
        groupName: item['group_1'] ? item['group_1'] : item.label ?? "Gral.",
        value: item.value,
      }))
      : []
  }
}

export const widgetsLine: CommonWidget = {
  /**************************************************************************
   *                                LINES
   ***************************************************************************/

  alertsLineTrendByMonthAndGeo: {
    title: 'Tendencia % EESS',
    // [Column, Row]
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'alerts-line-trend-by-month-and-geo',
      type: 'line',
      colors: ['#269102', '#d64550'],
      radius: [40, 85],
      center: ['40%', '55%'],
      showHistoric: false,
      showSample: false,
      //legendOrient: 'vertical',
      legendItemWidth: 10,
      groups: [
        '% Excelente. Más de 30 encuestas',
        '% Criticas. Menos de 10 encuestas',
      ],
      wrapXAxisText: true,
      mapper: (data: any) => {

        //console.log("alertsLineTrendByMonthAndGeo")
        //console.log(data)
        const groupByCategory = data.reduce((all: any, item: any) => {
          // Calculos
          const excelente = item.value.answeredCount >= 30 ? 1 : 0
          const neutro =
            item.value.answeredCount >= 10 && item.value.answeredCount < 30
              ? 1
              : 0
          const critico = item.value.answeredCount < 10 ? 1 : 0

          const group = item['group_0']
          all[group] = all[group] ?? {
            excelente: 0,
            neutro: 0,
            critico: 0,
          }

          const current = {
            //...all[group],
            groupName: item.groupName,
            group: group,
            excelente: all[group].excelente + excelente,
            neutro: all[group].neutro + neutro,
            critico: all[group].critico + critico,
            total:
              all[group].excelente +
              excelente +
              all[group].neutro +
              neutro +
              all[group].critico +
              critico,
          }

          all[group] = current
          return all
        }, {})

        const result = Object.keys(groupByCategory)
          .sort((a, b) => (a > b ? 1 : b > a ? -1 : 0))
          .map((key: string, idx: number) => {
            const item = groupByCategory[key]
            const groups = item.group !== undefined && item.group.split('-')
            return [
              {
                id: idx,
                group: '% Criticas. Menos de 10 encuestas',
                category:
                  item.groupName + (groups && groups[0] ? ' ' + groups[0] : ''),
                value: Math.round((100 * item.critico) / item.total),
              },
              {
                id: idx,
                group: '% Excelente. Más de 30 encuestas',
                category:
                  item.groupName + (groups && groups[0] ? ' ' + groups[0] : ''),
                value: Math.round((100 * item.excelente) / item.total),
              },
            ]
          })
          .flat(1)

        return result
      },
      indicators: [
        {
          //key: 'alert-first-response-time',
          indicator: 'survey-count',
          grouped: 'formattedMonth,geoLocation',
          keyExtract: [
            'group',
            'value',
            'groupName',
            'count',
            'group_0',
            'group_1',
          ],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            featureExclude: ['groupByTopLocation'],
            periods: 10,
          },
        },
      ],
    },
  },
  alertsLineTrendByGeo: {
    title: '% EESS por Región',
    // [Column, Row]
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'alerts-line-trend-by-geo',
      type: 'line',
      radius: [50, 100],
      center: ['40%', '55%'],
      showHistoric: false,
      showSample: false,
      //legendOrient: 'vertical',
      legendItemWidth: 10,
      groups: [
        '% Excelente. Más de 30 encuestas',
        '% Criticas. Menos de 10 encuestas',
      ],
      colors: ['#269102', '#d64550'],
      wrapXAxisText: true,
      mapper: (data: any) => {
        const groupByCategory = data.reduce((all: any, item: any) => {
          // Calculos
          const excelente = item.value.answeredCount >= 30 ? 1 : 0
          const neutro =
            item.value.answeredCount >= 10 && item.value.answeredCount < 30
              ? 1
              : 0
          const critico = item.value.answeredCount < 10 ? 1 : 0

          const group = item?.['group_0'] ?? item?.['group']
          all[group] = all[group] ?? {
            excelente: 0,
            neutro: 0,
            critico: 0,
          }

          const current = {
            //...all[group],
            group: group,
            excelente: all[group].excelente + excelente,
            neutro: all[group].neutro + neutro,
            critico: all[group].critico + critico,
            total:
              all[group].excelente +
              excelente +
              all[group].neutro +
              neutro +
              all[group].critico +
              critico,
          }

          all[group] = current
          return all
        }, {})

        const result = Object.keys(groupByCategory)
          .sort((a, b) => (a > b ? 1 : b > a ? -1 : 0))
          .map((key: string) => {
            const item = groupByCategory[key]
            return [
              {
                ...item,
                group: '% Criticas. Menos de 10 encuestas',
                category: item.group,
                value: Math.round((100 * item.critico) / item.total),
              },
              {
                ...item,
                group: '% Excelente. Más de 30 encuestas',
                category: item.group,
                value: Math.round((100 * item.excelente) / item.total),
              },
            ]
          })
          .flat(1)

        return result
      },
      indicators: [
        {
          indicator: 'survey-count',
          grouped: 'geoLocation',
          keyExtract: ['group', 'value', 'groupName', 'count', 'groupId', 'group_0'],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            featureExclude: ['groupByTopLocation'],
            ancestorName: 0,
            periods: 10,
          },
        },
      ],
    },
  },
  surveyLineTrendByMonth: {
    title: 'Sin titulo',
    // [Column, Row]
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'survey-line-trend-by-month',
      type: 'line',
      colors: DEFAULT_COLORS_WIDGETS,
      radius: [40, 85],
      center: ['40%', '55%'],
      showHistoric: false,
      showSample: false,
      //legendOrient: 'vertical',
      showYLine: true,
      smooth: false,
      multiAxis: true,
      legendItemWidth: 10,
      groups: [
        '# Encuestas',
        '% Alertas'
      ],

      //wrapXAxisText: true,
      mapper: (data: any) => {

        //console.log("surveyLineTrendByMonth mapper")
        //console.log(data)
        const resultSurvey = data['survey-count'].map((item: any) => ({
          label: item.groupName,
          groupName: item.groupName,
          group: "# Encuestas",
          category: item.groupName,
          value: item.value.answeredCount,
          yAxisIndex: 0,
          symbol: ''
        }))

        const resultAlert = data['alert-first-response-time'].map((item: any) => ({
          label: item.groupName,
          groupName: item.groupName,
          group: "% Alertas",
          category: item.groupName,
          value: item.fastPerc,
          yAxisIndex: 1,
          symbol: ''
        }))

        //console.log([...resultSurvey, ...resultAlert])

        return [...resultSurvey, ...resultAlert]

      },
      indicators: [
        {
          key: 'survey-count',
          indicator: 'survey-count',
          grouped: 'formattedMonth',
          keyExtract: [
            'value',
            'groupName',
            'group_0',
          ],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group_0', value: 'asc' },
          extras: {
            //featureExclude: ['groupByTopLocation'],
            periods: 10,
          },
        },
        {
          key: 'alert-first-response-time',
          indicator: 'alert-first-response-time',
          grouped: 'formattedMonth',
          keyExtract: [
            'group',
            'value',
            'groupName',
            'count',
            'fastCount',
            'fastPerc',
            'slowCount',
            'slowPerc',
            'group_0'
          ],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            alertStatus: 'IN_PROCESS,CLOSED',
            periods: 10,
          },
        },
      ],
    },
  },
  surveyLineTrendByWeek: {
    title: 'Sin titulo',
    // [Column, Row]
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'survey-line-trend-by-week',
      type: 'line',
      colors: DEFAULT_COLORS_WIDGETS,
      radius: [40, 85],
      center: ['40%', '55%'],
      showHistoric: false,
      showSample: false,
      //legendOrient: 'vertical',
      showYLine: true,
      smooth: false,
      legendItemWidth: 10,
      multiAxis: true,
      groups: [
        '# Encuestas',
        '% Alertas'
      ],
      mapper: (data: any) => {
        const resultSurvey = data['survey-count'].map((item: any) => ({
          label: 'Sem. ' + item?.group_0?.split('-')[1],
          groupName: 'Sem. ' + item?.group_0?.split('-')[1],
          group: "# Encuestas",
          category: 'Sem. ' + item?.group_0?.split('-')[1],
          value: item.value.answeredCount,
          yAxisIndex: 0,
          symbol: ''
        }))

        const resultAlert = data['alert-first-response-time'].map((item: any) => ({
          label: 'Sem. ' + item?.group?.split('-')[1],
          groupName: 'Sem. ' + item?.group?.split('-')[1],
          group: "% Alertas",
          category: 'Sem. ' + item?.group?.split('-')[1],
          value: item.fastPerc,
          yAxisIndex: 1,
          symbol: ''
        }))
        return [...resultSurvey, ...resultAlert]

      },
      indicators: [
        {
          key: 'survey-count',
          indicator: 'survey-count',
          grouped: 'formattedWeek',
          keyExtract: [
            'value',
            'groupName',
            'group_0',
          ],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group_0', value: 'asc' },
          extras: {
            //featureExclude: ['groupByTopLocation'],
            periods: 13,
          },
        },
        {
          key: 'alert-first-response-time',
          indicator: 'alert-first-response-time',
          grouped: 'formattedWeek',
          keyExtract: [
            'group',
            'value',
            'groupName',
            'count',
            'fastCount',
            'fastPerc',
            'slowCount',
            'slowPerc',
            'group_0'
          ],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            alertStatus: 'IN_PROCESS,CLOSED',
            periods: 13,
          },
        },
      ],
    },
  },
  lineByMonth: {
    title: 'Sin titulo',
    // [Column, Row]
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'line-trend-by-month',
      type: 'line',
      colors: DEFAULT_COLORS_WIDGETS,
      radius: [40, 85],
      center: ['40%', '55%'],
      showHistoric: false,
      showSample: false,
      //legendOrient: 'vertical',
      showYLine: true,
      smooth: false,
      legendItemWidth: 10,
      multiAxis: true,
      //groups: ['Satisfacción'],
      mapper: (data: any, extra: any) => {
        //console.log('getLineTrendWidget mapper!!!!')
        //console.log(data)
        //console.log(extra)

        const group = extra?.config?.groups?.[0]
        const groupsMapping = extra?.config?.groupsMapping

        const resultSurvey = data.map((item: any) => ({
          label: item.groupName,
          groupName: item.groupName,
          group: group,
          category: item.groupName,
          value: item.value,
          yAxisIndex: 0,
          symbol: ''
        }))
        //console.log(resultSurvey)
        return resultSurvey
      },
      indicators: [
        {
          key: 'line-by-month-satisfaction',
          indicator: 'satisfaction',
          grouped: 'formattedMonth',
          keyExtract: [
            'group',
            'value',
            'groupName',
            'count',
            'fastCount',
            'fastPerc',
            'slowCount',
            'slowPerc',
            'group_0'
          ],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            alertStatus: 'IN_PROCESS,CLOSED',
            periods: 6,
          },
        },
      ],
    },
  },
  lineDetailedByMonthAndGeo: {
    title: 'Satisfacción General',
    // [Column, Row]
    position: [0, 0],
    size: [4, 3],
    config: {
      id: 'line-detailed-by-month-and-geo',
      type: 'lineDetailed',
      //fillMode: 'gradient',
      fillMode: '',
      colors: DEFAULT_COLORS_WIDGETS, //ojo aca usaba pie colors
      showValues: false,
      //percentageScale: false,
      shadow: false,
      mapper: lineDetailedMonthAndGeoMapper,
      indicators: [
        {
          indicator: 'satisfaction',
          grouped: 'formattedMonth,geoLocation',
          keyExtract: ['group_0', 'group_1', 'groupId_0', 'value', 'groupName','metricTargets'],
          label: 'group',
          value: 'value',
          sort: { sortBy: 'group_0', value: 'asc' },
          singleton: true,
          extras: {
            periods: 6,
          },
        },
      ],
    },
  },
  lineByMonthAndCategory: {
    title: 'Satisfacción General',
    // [Column, Row]
    position: [0, 0],
    size: [4, 3],
    config: {
      id: 'line-by-month-and-category',
      type: 'line',
      //fillMode: 'gradient',
      fillMode: '',
      colors: DEFAULT_COLORS_WIDGETS, //ojo aca usaba pie colors
      showValues: false,
      //percentageScale: false,
      shadow: false,
      mapper: (data: any) => {
        //console.log('lineByMonthAndCategory!!!!!!!!')
        //console.log(data)
        const finalData = data.map((cat: any) => {
          return cat?.tags?.map((tag: any) => ({
            ...tag,
            category: tag.parentGroup ?? cat.group,
            label: cat.groupName,
            group: tag.group,
            groupName: tag.groupName,
            value: tag.count
          }))
        }).flat(1)
        //console.log(finalData)
        return finalData
      },
      indicators: [
        {
          indicator: 'SENTIMENT',
          grouped: 'formattedMonth,tag',
          keyExtract: ['group_0', 'group_1', 'groupId_0', 
            'value', 'groupName', 'group', 'groupName', 
            'count', 'positive', 'negative', 'neutral',
            'sentiment', 'index', 'tags'],
          label: 'group',
          value: 'value',
          sort: { sortBy: 'group_0', value: 'asc' },
          singleton: true,
          extras: {
            periods: 6,
          },
        },
      ],
    },
  },
}

const normalizeHistoricData = (data: any, radialIndicators: any) => {

  // 1. Obtener todos los grupos únicos de todos los arrays
    const groups: string[] = [];    
    Object.entries(data).forEach((item: any) => {
        if(item[0].includes('-ld')) {
          item[1].forEach((item: any) => {
            if(!groups.includes(item.group)) {
              groups.push(item.group);
            }
          });
        }
    });

  const normalizeData = Object.keys(data).filter((key: any) => key.includes('-ld'))
    .reduce((acc: any, curr: any) => {
      const indicator = curr.replace('-ld', '');
      const currentData = data[curr];
      const historicData = data[indicator + '-hist'];
      //console.log(historicData)

      const historicValue = historicData?.[0]?.value;
      const currentValue = historicData?.[1]?.value;

      //console.log(`calculando historic data ${indicator} - values: hist: ${historicValue} curr: ${currentValue}`)
      const currentDataGroups = currentData.map((cur: any) => cur.group);
      const missingGroups = groups.filter((group:any) => !currentDataGroups.includes(group));
      
      const item = {
        ...acc,
        [curr]: [
          ...currentData.map((item: any) => ({
            ...item,
            group: item.group ?? item['group_0'],
            valueNorm: item['value_norm'],
            indicatorValue: currentValue,
            trend: currentValue > historicValue ? 'up' : 'down'
          })),
          ...missingGroups.map((key: string, idx: number) => ({
            id: currentData.length + idx,
            value: 0,
            group: key,
            value_norm: 0,
            count: 0,
            label: key,
            valueNorm: 0,
            trend: "down",        
          }))
        ]
      };

      return item;
    }, {});

    return normalizeData;

  /*
  
  const indData = data[radialIndicators?.[0] + '-ld']
  const biggestGroup = indData?.[indData.length - 1]?.['group_0']
  
  return Object.keys(data)
    .filter((item: any) => item.includes('-ld'))
    .reduce((acc: any, curr: any) => {
      const currentData = data[curr]

      const historicValue = currentData
        .find((histItem: any) => histItem['group_0'] !== biggestGroup)
        .reduce((acc: any, curr: any) => curr.value, 0).value

      return {
        ...acc,
        [curr]: currentData
          .filter((item: any) => item['group_0'] === biggestGroup)
          .map((item: any) => {
            const historicValue = currentData
              .find((histItem: any) => histItem['group_0'] !== biggestGroup
                && item['group_1'] === histItem['group_1'])?.value
            const currentValue = item.value
            //console.log(`historic value ${historicValue} for ${item['group_1']} current ${currentValue}`)
            const trend = currentValue > historicValue ? 'up' : 'down'

            return {
              id: item.id,
              groupName: item.groupName,
              label: item['group_1'],
              group: item['group_1'],
              value: currentValue,
              valueNorm: item['value_norm'],
              trend: trend
            }
          })
      }
    }, {})*/
}

const truncValue = (value: number, precision: number) => {
  //console.log(`normalizing value ${value} with precision ${precision}`)
  const n = Math.pow(10, precision)
  return Math.trunc(value * n) / n
}

export const radialMapperByIndicator = (data: any, extra: any) => {
  //console.log('render lined detailed mapper by indicator')
  //console.log(data)
  //console.log(extra)

  const radialIndicators = extra?.config?.radialIndicators ?? []
  const normalizedData = normalizeHistoricData(data, radialIndicators)

  const useNormalizedRadial = extra?.config?.useNormalizedRadial ?? true

  //console.log(normalizedData)

  const mainIndicatorKey =
    extra?.config?.mainIndicatorKey ??
    extra?.config?.mainIndicator + '-by-month'

  const mainIndicatorGralKey =
    extra?.config?.mainIndicatorGralKey ??
    extra?.config?.mainIndicator + '-gral-by-month'
  //console.log(radialIndicators)

  const indicatorsNames = extra?.config?.indicatorsNames

  const radialKeys =
    radialIndicators !== undefined &&
      radialIndicators[0] !== undefined &&
      normalizedData !== undefined &&
      normalizedData[radialIndicators[0] + '-ld'] !== undefined
      ? normalizedData[radialIndicators[0] + '-ld'].map((item: any) => (item.group ?? item['group_1']))
      : []

  const radialData = Object.keys(indicatorsNames)
    .map((indicator: any, indIdx: number) => {
      const itemData = indicator === 'alert-counters-wow'
        || indicator === 'alert-counters-rescue'
        || indicator === 'alert-counters-not-handled'
        || indicator === 'alert-counters-handled' ?
        normalizedData['alert-counters-ld'] ?? normalizedData[indicator + '-ld'] :
        normalizedData[indicator + '-ld']


      let alertCountersByStatus: any = {}
      if (indicator === 'alert-counters-not-handled' || indicator === 'alert-counters-handled') {
        alertCountersByStatus = itemData !== undefined
          ? itemData.reduce((acc: any, curr: any) => {
            const group = curr.group
            const group1 = curr.group_1
            const value = (acc[group]?.[group1] ?? 0) + curr.value.totalCount
            const total = (acc[group]?.total ?? 0) + curr.value.totalCount
            if (group1 !== 'wow') {
              acc[group] = {
                ...acc[group],
                total: total,
                [group1]: value
              }
            }

            return acc
          }, {})
          : undefined

        //console.log('Alert counter by status')
        //console.log(alertCountersByStatus)
      }

      var values = {}
      if (itemData !== undefined && itemData.length > 0) {
        values = itemData.reduce((acc: any, curr: any, idx: any) => {
          const geo = curr.label !== undefined ? curr.label : curr.group

          const normValue = useNormalizedRadial
            ? (curr.valueNorm ?? curr['value_norm'])
            : curr.value

          //Iterar sobre todos los valores
          //truncar a la precision elegida y sumarle a cada valor un valor mas chico que la precision ()

          const normPrecision = 6
          const precision = normPrecision - 1
          const adder = 0.01 / Math.pow(10, precision)

          const index = (idx + 1) * (indIdx + 1)
          var currentValue = truncValue(curr.value, normPrecision) + adder * index
          var normalizedValue = truncValue(normValue, normPrecision) + adder * index

          //console.log(`normalized value ${currentValue} origin ${curr.value} for ${geo}`)

          if (indicator === 'alert-counters-wow') {
            currentValue = truncValue(curr.value.positivePercentage ?? 0, normPrecision) + adder * index
            normalizedValue = truncValue(curr.value.positivePercentage ?? 0, normPrecision) + adder * index
          } else if (indicator === 'alert-counters-rescue') {
            currentValue = truncValue(curr.value.negativePercentage ?? 0, normPrecision) + adder * index
            normalizedValue = truncValue(curr.value.negativePercentage ?? 0, normPrecision) + adder * index
          } else if (indicator === 'alert-counters-not-handled') {
            const noGestionada = alertCountersByStatus?.[geo]?.['no gestionada'] ?? 0
            const total = alertCountersByStatus?.[geo]?.['total'] ?? 0
            const percentage = (noGestionada * total) / 100

            currentValue = truncValue(percentage ?? 0, normPrecision) + adder * index
            normalizedValue = truncValue(percentage ?? 0, normPrecision) + adder * index
          } else if (indicator === 'alert-counters-handled') {
            const gestionada = alertCountersByStatus?.[geo]?.['en proceso'] ?? 0
            const cerrada = alertCountersByStatus?.[geo]?.['cerrada'] ?? 0
            const total = alertCountersByStatus?.[geo]?.['total'] ?? 0
            const percentage = ((gestionada + cerrada) * 100) / total

            //console.log(`alert counters by status ${gestionada} ${cerrada} ${total} ${percentage}`)

            currentValue = truncValue(percentage ?? 0, normPrecision) + adder * index
            normalizedValue = truncValue(percentage ?? 0, normPrecision) + adder * index
          }

          return {
            ...acc,
            [geo]: normalizedValue >= 0 ? normalizedValue : 0,
            [`${geo}_norm`]: currentValue >= 0 ? currentValue : 0,
            indicatorValue: curr.indicatorValue >= 0 ? curr.indicatorValue : 0,
            trend: curr.trend
          }
        }, {})
      } else if (itemData !== undefined && radialKeys !== undefined) {
        values = radialKeys.reduce((acc: any, curr: any) => {
          return {
            ...acc,
            [curr]: 0,
            [`${curr}_norm`]: 0,
            indicatorValue: 0,
            trend: 'down'
          }
        }, {})
      } else if (radialKeys !== undefined) {
        const maxValue = extra?.config?.maxValue === 5
          || extra?.config?.maxValue === 10
          ? extra?.config?.maxValue + 0.1
          : 101
        values = radialKeys.reduce((acc: any, curr: any) => {
          return {
            ...acc,
            [curr]: maxValue,
            [`${curr}_norm`]: undefined,
            indicatorValue: undefined,
            trend: 'up'
          }
        }, {})
      }

      return {
        indicator: indicatorsNames[indicator],
        ...values
      }
    })

  const indNames = normalizedData[radialIndicators[0] + '-ld'] !== undefined
    && normalizedData[radialIndicators[0] + '-ld'].reduce !== undefined
    ? {
      ...normalizedData[radialIndicators[0] + '-ld']
        .reduce((acc: any, curr: any) => ({
          ...acc,
          [curr.id]: curr.label ?? curr.group
        }), {})
    }
    : {}


  //console.log("data!!!!!!!!!!!")
  //console.log(data)
  //console.log(mainIndicatorGralKey)

  //si hace merge de la info de un segundo indicador general 
  //TODO: refactorizar y poder meter varios indicadores sobre el mismo set de datos
  type Item = {
    id: number;
    [key: string]: any;
  };

  const first: Item[] = data[mainIndicatorKey] || [];
  const second: Item[] = data[mainIndicatorGralKey] || [];

  const existingIds = new Set<number>(first.map(item => item.id));
  const newData: Item[] = [...first];

  second.forEach((item) => {
    let newItem = { ...item, group_1: 'Gral.' };

    while (existingIds.has(newItem.id)) {
      newItem.id += 1;
    }

    existingIds.add(newItem.id);
    newData.push(newItem);
  });
  //console.log(newData)

  return {
    ...lineDetailedMonthAndGeoMapper(newData),
    //...lineDetailedMonthAndGeoMapper(data[mainIndicatorGralKey]),
    metrics: [],
    radials: {
      keys: radialKeys,
      data: radialData,
      //maxValue: 100,
      //minValue: 90,
      useNormalization: true,
      indicatorsNames: indNames
    },
  }
}


const radialMapperByGeo = (data: any, extra: any) => {
  //console.log('render oxxo lined detailed mapper by geo')
  //console.log(data)
  const indicatorsNames = extra?.config?.indicatorsNames ?? {}
  const radialIndicators = extra?.config?.radialIndicators ?? []

  const normalizedData = normalizeHistoricData(data, radialIndicators)

  //console.log(radialIndicators)

  const radialKeys =
    radialIndicators !== undefined &&
      radialIndicators[0] !== undefined &&
      normalizedData !== undefined &&
      normalizedData[radialIndicators[0] + '-ld'] !== undefined
      ? normalizedData[radialIndicators[0] + '-ld'].map((item: any) => item.group)
      : []
  //console.log(radialKeys)

  const radialData = radialKeys.map((geo: any) => {
    const values = radialIndicators.reduce((acc: any, curr: any, index: any) => {
      const current = indicatorsNames[curr]
      const valueCurrent = normalizedData[curr + '-ld']
        .find((item: any) => item.group === geo)?.value
      const valueNorm = normalizedData[curr + '-ld']
        .find((item: any) => item.group === geo)?.value

      return {
        ...acc,
        [current]: valueNorm,
        [`${current}_norm`]: valueCurrent,
      }
    }, {})

    return {
      indicator: geo,
      ...values,
      trend: 'up',
    }
  })

  //console.log(radialData)
  const mainIndicatorKey =
    extra?.config?.mainIndicatorKey ??
    extra?.config?.mainIndicator + '-by-month'

  return {
    ...lineDetailedMonthAndGeoMapper(data[mainIndicatorKey]),
    metrics: [],
    radials: {
      keys: radialIndicators,
      indicatorsNames: indicatorsNames,
      data: radialData,
      useNormalization: true,
      //maxValue: 100,
      //minValue: 90,
    },
  }
}

export const getLineDetailedRadar = (props: {
  title: string
  mainIndicator: string
  mainIndicatorGral?: string
  radialIndicators?: string[]
  radialType?: 'byGeo' | 'byIndicator'
  extraConfigs?: { [key: string]: any }
  extras?: { [key: string]: any }
  criticalMomentInclude?: number[]
  geoLocationInclude?: number[]
  logicalLocationInclude?: number[]
  indicatorsNames: { [key: string]: string }
  position?: number[]
  size: number[]
  groupByLevel?: number
  useNormalizedRadial?: boolean
  normalizeBottom?: number
  normalizeTop?: number
  radialGrouped?: string | Record<string, string>
  mapper?: (data: Object[], extra?: any) => any
  // Sorters
  mainSort?: SortConfig
  historicSort?: SortConfig
  radialSort?: SortConfig
  filters?: FiltersUI
  geoGrupedCondition?: { [key: string]: { group: string, level: number } }
}) => {
  const {
    mainIndicator,
    mainIndicatorGral,
    radialIndicators = [],
    position,
    size,
    radialType = 'byGeo',
    extraConfigs = {},
    extras = {},
    criticalMomentInclude,
    geoLocationInclude,
    logicalLocationInclude,
    indicatorsNames,
    groupByLevel = 1,
    useNormalizedRadial = true,
    normalizeBottom = 50,
    normalizeTop = 100,
    title = undefined,
    filters = undefined,
    geoGrupedCondition = undefined
  } = props
  //TODO refactorizar las config de los indicadores
  const mainKey = mainIndicator + '-by-month'

  // segun el filtro aplicado en la geo deberia cambiar entre 'formattedMonth,logicalLocation', o 'formattedMonth,geoLocation',

  //console.log('filters!!!!!!!')
  //console.log(filters)

  const matchedKey = filters?.geographicDistributions.find(value => geoGrupedCondition?.hasOwnProperty(value))


  const gruped = matchedKey !== undefined && geoGrupedCondition !== undefined
    ? geoGrupedCondition[matchedKey]
    : (geoGrupedCondition !== undefined
      ? geoGrupedCondition['default']
      : { group: 'formattedMonth,geoLocation', level: groupByLevel });
  //console.log("gruped!!!!!!!!!!!!!!!!")
  //console.log(gruped)


  const mainIndicatorConfig = {
    indicator: mainIndicator,
    key: mainKey,
    grouped: gruped.group,  //'formattedMonth,logicalLocation',
    keyExtract: ['group_0', 'group_1', 'groupId_0', 'value', 'groupName'],
    label: 'group',
    value: 'value',
    sort: props.mainSort ?? { sortBy: 'group_0', value: 'asc' },
    singleton: true,
    extras: {
      criticalMomentInclude: criticalMomentInclude,
      geographicDistributions: geoLocationInclude,
      logicalDistributions: logicalLocationInclude,
      periods: 6,
      //groupByLevel: 1,
      ...extras,
      groupByLevel: gruped.level

    },
  }

  const mainKeyGral = mainIndicatorGral ? mainIndicatorGral + '-gral-by-month' : undefined
  const mainIndicatorGralConfig = {
    indicator: mainIndicator,
    key: mainKeyGral,
    grouped: 'formattedMonth',
    keyExtract: ['group_0', 'group_1', 'groupId_0', 'value', 'groupName'],
    label: 'group',
    value: 'value',
    sort: props.mainSort ?? { sortBy: 'group_0', value: 'asc' },
    singleton: true,
    extras: {
      criticalMomentInclude: criticalMomentInclude,
      geographicDistributions: geoLocationInclude,
      logicalDistributions: logicalLocationInclude,
      periods: 6,
      //groupByLevel: 1,
      ...extras,
    },
  }

  /*const indicators = [
    'satisfaction', 'service-speed', 'service', 'willingness-to-recommend'
  ]*/

  const radialFormula = extraConfigs.formulaRadial ?? extras.formula;
  const radialIndicatorsConfig = radialIndicators.map((ind: string) => {

    const normalizationExtras = /*ind === 'survey-response-counters'
      ? {}
      : */{
      normalize: useNormalizedRadial,
      normalize_a: normalizeBottom,
      normalize_b: normalizeTop,
      periods: 2,
      groupByLevel: gruped.level ?? groupByLevel,
    }

    const radialGrouped = isObject(props.radialGrouped)
      && props.radialGrouped[ind]
      ? props.radialGrouped[ind]
      : (isString(props.radialGrouped) ? props.radialGrouped : 'geoLocation')

    return {
      indicator: ind,
      key: ind + '-ld',
      grouped: radialGrouped,
      keyExtract: ['value', 'group', 'groupName',
        'value_norm', 'count', 'group_0', 'group_1'],
      label: 'group',
      value: 'value',
      sort: props.historicSort ?? { sortBy: 'group', value: 'asc' },
      singleton: true,
      extras: {
        criticalMomentInclude: criticalMomentInclude,
        geographicDistributions: geoLocationInclude,
        logicalDistributions: logicalLocationInclude,
        resultType: ind === 'survey-response-counters' ? "answeredPerc" : undefined,
        ...extras,
        ...normalizationExtras,
        formula: radialFormula,
        groupByLevel: gruped.level ?? groupByLevel,

      },
    }
  })

  const historicIndicatorsConfig = radialIndicators.map((ind: string) => {

    return ({
      indicator: ind,
      grouped: 'formattedMonth',
      key: ind + '-hist',
      keyExtract: ['value', 'group', 'groupName', 'value_norm',
        'count', 'group_0', 'group_1'],
      label: 'group',
      value: 'value',
      sort: props.historicSort ?? { sortBy: 'group', value: 'asc' },
      singleton: true,
      extras: {
        criticalMomentInclude: criticalMomentInclude,
        geographicDistributions: geoLocationInclude,
        logicalDistributions: logicalLocationInclude,
        resultType: ind === 'survey-response-counters' ? "answeredPerc" : undefined,
        ...extras,
        periods: 2,
        groupByLevel: gruped.level ?? groupByLevel,
      },
    })
  })
  //console.log ("mainKeyGral ? mainIndicatorGralConfig: ''")
  //console.log (mainKeyGral ? mainIndicatorGralConfig: '')
  const mapper = props.mapper !== undefined
    ? props.mapper
    : (radialType === 'byGeo' ? radialMapperByGeo : radialMapperByIndicator)

  return {
    ...widgetsLine.lineDetailedByMonthAndGeo,
    //@ts-ignore
    position: position,
    size: size,
    title: title ?? widgetsLine.lineDetailedByMonthAndGeo.title,
    config: {
      ...widgetsLine.lineDetailedByMonthAndGeo.config,
      ...extraConfigs,
      id: mainKey,
      radialIndicators: radialIndicators,
      mainIndicator: mainIndicator,
      mainIndicatorKey: mainKey,
      useNormalizedRadial: useNormalizedRadial,
      indicatorsNames: indicatorsNames,
      mapper: mapper,
      indicators: [
        ...(mainKeyGral ? [mainIndicatorGralConfig] : []),
        mainIndicatorConfig,
        ...radialIndicatorsConfig,
        ...historicIndicatorsConfig
      ],
    },
  }

}